import React, { useEffect, useRef, useState } from 'react';
import { cn } from '../lib/utils';

const ANIMATION_CLASS = {
  'fade-up': 'reveal-fade-up',
  'fade-in': 'reveal-fade-in',
  'scale-in': 'reveal-scale-in',
};

/**
 * Lightweight scroll-reveal via IntersectionObserver.
 * Respects prefers-reduced-motion.
 */
const Reveal = ({
  children,
  animation = 'fade-up',
  delay = 0,
  className,
  as: Tag = 'div',
  threshold = 0.1,
}) => {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return undefined;

    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduced) {
      setVisible(true);
      return undefined;
    }

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
          observer.disconnect();
        }
      },
      { threshold, rootMargin: '0px 0px -24px 0px' }
    );

    observer.observe(el);
    return () => observer.disconnect();
  }, [threshold]);

  return (
    <Tag
      ref={ref}
      className={cn(
        'reveal',
        ANIMATION_CLASS[animation] || ANIMATION_CLASS['fade-up'],
        visible && 'is-visible',
        className
      )}
      style={delay ? { transitionDelay: `${delay}ms` } : undefined}
    >
      {children}
    </Tag>
  );
};

export default Reveal;
